import React from "react";
import "./ServicesCenter.scss";
import "./Responsive.scss";
import Service from "../../components/Service/Service";

const ServicesCenter = () => {
  const fakeServices = [
    {
      id: 1,
      name: "قرچک",
      haveRate: true,
      rate: "3.5",
      manager: "شهریسوند",
      address: "پاکدشت خ شاهد رویروی اداره پست پ67 واحد 18",
      location: [35.73853, 51.4326],
    },
    {
      id: 2,
      name: "قرچک",
      haveRate: false,
      rate: "0",
      manager: "شهریسوند",
      address: "پاکدشت خ شاهد رویروی اداره پست پ67 واحد 18",
      location: [35.73853, 51.4326],
    },
    {
      id: 3,
      name: "قرچک",
      haveRate: false,
      rate: "0",
      manager: "شهریسوند",
      address: "پاکدشت خ شاهد رویروی اداره پست پ67 واحد 18",
      location: [35.73853, 51.4326],
    },
  ];
  return (
    <section className="servicesCenterWrapper mobile">
      <div className="desktop">
        <div className="servicesWrapper maxWidth">
          <div className="formGroup">
            <div className="caption">
              <select>
                <option value="" disabled selected>
                  استان
                </option>
                <option>تهران</option>
                <option>اصفهان</option>
              </select>
            </div>
          </div>
          <div className="formGroup">
            <div className="caption">
              <select>
                <option value="" disabled selected>
                  شهر
                </option>
                <option>تهران</option>
                <option>اصفهان</option>
              </select>
            </div>
          </div>
          <div className="formGroup">
            <div className="caption">
              <select>
                <option value="" disabled selected>
                  خدمات خود را انتخاب کنید
                </option>
                <option>تهران</option>
                <option>اصفهان</option>
              </select>
            </div>
          </div>
        </div>
        <Service maxWidth={true} data={fakeServices} />
      </div>
    </section>
  );
};

export default React.memo(ServicesCenter);
